import type { FC } from 'react';
const HomePageSectionLessonHeader: FC = () => {
  return <div className="text-center text-orangeSix" data-sentry-component="HomePageSectionLessonHeader" data-sentry-source-file="HomePageSectionLessonHeader.tsx">
      <h3 className="mb-4 text-lg font-semibold  text-blueFive sm:text-2xl">سخت نگیر؛ یاد بگیر:</h3>
      <h2 className="mb-4 text-2xl font-bold text-blueFive sm:text-4xl">با آی‌نو از پسش برمیای</h2>
      <p className="text-justify text-blueSix">
        از آموزش درس به درس کتاب‌های درسی تا آمادگی برای تیزهوشان و کنکور، همه چیز اینجا آماده است! با بهترین ویدیوهای آموزشی
        برای موفقیت در مدرسه و آزمون‌ها، همراه تو هستیم. فقط ویدیوها رو ببین و قدم‌به‌قدم جلو برو.
      </p>
    </div>;
};
export default HomePageSectionLessonHeader;